import { LOGO, CITY_URL, EMAIL, QML_REPO_URL, scrollToId } from "@/constants/assets";
import { Github } from "lucide-react";

const LINKS = [
  { label: "THE CITY", id: "city" },
  { label: "LIFE IN THE CITY", id: "life" },
  { label: "WHY SIMULATE", id: "research" },
  { label: "HOW IT RUNS", id: "systems" },
  { label: "THE METHOD", id: "method" },
  { label: "THE EXPERIMENTS", id: "experiments" },
  { label: "HOW IT WORKS", id: "tech" },
  { label: "ABOUT", id: "about" },
];

export default function Footer() {
  return (
    <footer className="bg-gb-bg border-t-2 border-gb-line pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12">
          <div className="md:col-span-5">
            <img src={LOGO} alt="replicant" className="h-10 w-auto" />
            <p className="mt-5 max-w-xs text-[12px] leading-relaxed text-gb-light/80">
              A simulation research studio. Deterministic truth, stochastic
              life. One town at a time.
            </p>
            <a
              data-testid="footer-email-link"
              href={`mailto:${EMAIL}`}
              className="mt-6 inline-flex items-center gap-2 font-pixel text-2xl text-gb-neon hover:text-gb-pale transition-colors"
            >
              {EMAIL}
            </a>
            <a
              data-testid="footer-qml-repo-link"
              href={QML_REPO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-2 text-[12px] tracking-[0.15em] text-gb-light/80 hover:text-gb-neon transition-colors w-max"
            >
              <Github size={13} /> GITHUB · QML-UNLOCKED (BOOK REPO)
            </a>
          </div>

          <div className="md:col-span-3">
            <p className="text-[10px] tracking-[0.3em] text-gb-accent mb-5">INDEX</p>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <a
                    data-testid={`footer-link-${l.id.toLowerCase()}`}
                    href={`#${l.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToId(l.id);
                    }}
                    className="text-[12px] tracking-[0.15em] text-gb-light/80 hover:text-gb-neon transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-[10px] tracking-[0.3em] text-gb-accent mb-5">LIVE SYSTEMS</p>
            <a
              data-testid="footer-live-city-link"
              href={CITY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between border-2 border-gb-line hover:border-gb-accent/60 px-4 py-4 group transition-colors"
            >
              <span className="text-[12px] tracking-[0.15em] text-gb-pale">
                THE LIVE CITY · INTERACT WITH IT
              </span>
              <span className="flex items-center gap-2 text-[9px] tracking-[0.2em] text-gb-neon">
                <span className="w-1.5 h-1.5 bg-gb-neon animate-blink" /> LIVE
              </span>
            </a>
            <p className="mt-4 text-[10px] tracking-[0.2em] text-gb-muted">
              LEDGER: INTACT ▮ REPLAY: VERIFIED ▮ MODEL: ON
            </p>
          </div>
        </div>

        <div className="border-t border-gb-line pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-[10px] tracking-[0.15em] text-gb-muted leading-relaxed">
            <p>© 2026 REPLICANT RESEARCH LLC · SIMULATION RESEARCH STUDIO</p>
            <p>5830 E 2ND ST, STE 7000 #39244, CASPER, WY 82609</p>
          </div>
          <p className="text-[10px] tracking-[0.2em] text-gb-muted">
            FICTIONAL EVIDENCE LEVEL · NO REAL PERSON OR PLACE IS REPRESENTED
          </p>
        </div>
      </div>
    </footer>
  );
}
